import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { ToasterService, TranslateService } from '@devinforius/i-essentials';
import { environment } from '@environments/environment';
import { OAuthService } from 'angular-oauth2-oidc';
import { EMPTY } from 'rxjs';

export const HttpTokenInterceptor: HttpInterceptorFn = (req, next) => {
  const oAuthServicce = inject(OAuthService);
  const toasterService = inject(ToasterService);
  const translateService = inject(TranslateService);
  const router = inject (Router);
  
  if (req.url.startsWith(environment.api.root) && !oAuthServicce.hasValidAccessToken()) {
    toasterService.push('error', translateService.translate('global.error'), translateService.translate('auth.error.disconnected-info'));
    router.navigate(['authentication']);

    return EMPTY;
  }

  const authReq = req.clone({
    setHeaders: {
      Authorization: `Bearer ${sessionStorage.getItem('access_token')}`,
    },
  });

  return next(authReq);
};
